import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import Coupon from '../models/Coupon';

export default function useOfferCoupon(studentId, schoolId) {
  return useQuery([studentId, schoolId, QueryKeys.COUPONS, QueryKeys.OFFER_PAGE], () => (
    Coupon
      .where({ forLandingPage: [studentId, schoolId] })
      .selectExtra(['imageUrl'])
      .first()
      .then((res) => res.data)
  ));
}
